import logo from 'assets/logoIcon.png'
import PageHeading from 'components/shared/PageHeading'
import { Button, ButtonGroup, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-scroll'

import icon1 from 'assets/about1.png'
import icon2 from 'assets/about2.png'
import icon3 from 'assets/about3.png'
import AboutCol from 'components/AboutCol'
import AboutCard from 'components/AboutCard'
import { Arrow } from 'assets/SVG'
const About = () => {
    return (
        <>
            <Container  className='' >


                <div className='d-flex justify-content-center align-items-center text-center pt-5 pb-4'>

                    <div >


                        <div className='text-center mb-3'>
                            <PageHeading center={true} image={logo} text={"About"} />
                        </div>
                        <h1 className='mb-0'>
                            <strong className='px-1'>
                                <span className="fw-semibold px-1">Living Wall:</span> Your turn-key solution
                            </strong>
                        </h1>
                        <h1>
                            <strong className='px-1'>for space transformation</strong>
                        </h1>


                        <Col md={8} className='mx-auto'>
                            <p>Discover how Living Wall combines digital media and audio-visual technology to bring your space to life.</p>
                        </Col>


                    </div>
                </div>

                <AboutCol />
                <Row className='py-5'>
                    {aboutData?.map((m, i) =>
                        <Col key={i} lg={4} md={6} className='mb-lg-0 mb-4' >

                            <AboutCard title={m.title} image={m.image} para={m.para} />
                        </Col>
                    )}
                </Row>





            </Container>

            <div className='aboutBg px-3'>


                <div>
                    <p className='text-white text-center fs-2 mb-md-5 mb-sm-3 mb-1 px-3'>
                        Looking for a partner to bring your vision to life with innovative, effective solutions?
                        <br className="d-none d-lg-block" />
                        Contact Living Wall today and let’s build something extraordinary.
                    </p>
                    <Col xl={2}  md={3} xs={10} className='mx-auto mt-4  '>
                        <ButtonGroup className="d-flex btn-group">
                            <Link
                                to="Connect"
                                smooth={true}
                                duration={500}
                            >
                                <Button
                                    className="btn-custom px-4"
                                >
                                    <small>Contact Us</small>
                                </Button>
                            </Link>
                            <span className="arrow">
                                <Arrow />
                            </span>
                        </ButtonGroup>

                    </Col></div>
            </div>
        </>

    )
}

export default About


const aboutData = [
    {
        image: icon1, 
        title: "Innovation", 
        para: <p>We push the boundaries of what's possible, turning bold ideas into engaging realities. Our forward-thinking approach ensures your space is equipped with future-ready technology.</p>
    },
    {
        image: icon2, 
        title: "Customer Focus", 
        para: <p>Your success is our priority. We listen, adapt, and build tailored solutions that meet your unique goals and exceed your audience's expectations.</p>
    },
    {
        image: icon3, 
        title: "Integration", 
        para: <p>We seamlessly integrate diverse technologies to streamline operations. Our cohesive solutions ensure your digital space is reliable, adaptable, and easy to manage.</p>
    }
];


